import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, reactive, computed } from 'vue';
import DataInput from '@/component/year-month-input.vue';
import { getPointsSetting, setPointsSetting } from '../../../api/points';
import { PointsSetting } from '../../../type/points';
//积分有效期弹窗

export default /*#__PURE__*/_defineComponent({
  __name: 'points',
  setup(__props) {

const modalVisible = ref(false);
const confirmLoading = ref<boolean>(false);
function handleOk() {
  modalVisible.value = !modalVisible.value;
  setSetting({
    has_expiration: settingData.value.has_expiration,
    expiration_before_month: settingData.value.expiration_before_month,
    expiration_before_day: settingData.value.expiration_before_day,
    expiration_clean_month: settingData.value.expiration_clean_month,
    expiration_clean_day: settingData.value.expiration_clean_day,
    expiration_notify_days: settingData.value.expiration_notify_days,
  });
}
function onModal() {
  modalVisible.value = !modalVisible.value;
}
function cancelModal(){
  modalVisible.value = !modalVisible.value;
  settingData.value = {
    ...settingData.value,
    has_expiration: initValue.value.has_expiration,
    expiration_before_month: initValue.value.expiration_before_month,
    expiration_before_day: initValue.value.expiration_before_day,
    expiration_clean_month: initValue.value.expiration_clean_month,
    expiration_clean_day: initValue.value.expiration_clean_day,
    expiration_notify_days: initValue.value.expiration_notify_days,
  };
}

//积分兑换比例是否可编辑
const ratioEdit = ref<boolean>(true);
function onRatio() {
  ratioEdit.value = false;
}
function ratioSave() {
  ratioEdit.value = true;
  setSetting({exchange_ratio: settingData.value.exchange_ratio,});
}
function ratioCancel() {
  ratioEdit.value = true;
  settingData.value = {
    ...settingData.value,
    exchange_ratio: initValue.value.exchange_ratio,
  };
}

const remindEdit = ref<string[]>([]);
function remindUpdata(val) {
  remindEdit.value =   [...new Set([...remindEdit.value, val])];
}
function remindSave(val: string) {
  remindEdit.value = [...remindEdit.value.filter(i => i != val)];
  //保存
  setSetting({
    [val + '_app']: settingData.value[val + '_app'],
    [val + '_sms']: settingData.value[val + '_sms'],
    [val + '_content']: settingData.value[val + '_content'],
  });
}
function remindCancel(val) {
  remindEdit.value = [...remindEdit.value.filter(i => i != val)];
  settingData.value = {
    ...settingData.value,
    [val + '_app']: initValue.value[val + '_app'],
    [val + '_sms']: initValue.value[val + '_sms'],
    [val + '_content']: initValue.value[val + '_content'],
  };
  //数据还原
}
function getDisable(key: string) {
  return Boolean(remindEdit.value.indexOf(key));
}
const settingData = ref<PointsSetting>(undefined as unknown as PointsSetting);
const initValue = ref<PointsSetting>({} as PointsSetting);
function changeSettingData(key, value) {
  settingData.value[key] = value;
}
async function getSetting() {
  const res = await getPointsSetting();
  if (res) {
    settingData.value = { ...res };
    initValue.value = { ...res };
  }
}
async function setSetting(data: Partial<PointsSetting>) {
  const res = await setPointsSetting({...initValue.value,...data});
  if (res) {
    // eslint-disable-next-line require-atomic-updates
    initValue.value ={...initValue.value,...data};
  }
}
getSetting();


return { __sfc: true,modalVisible, confirmLoading, handleOk, onModal, cancelModal, ratioEdit, onRatio, ratioSave, ratioCancel, remindEdit, remindUpdata, remindSave, remindCancel, getDisable, settingData, initValue, changeSettingData, getSetting, setSetting, DataInput }
}

})